import { getCurrentInstance } from 'vue'

export const useRoute = () => {
  const vm = getCurrentInstance()
  return vm.proxy.$route
}

export const useRouter = () => {
  const vm = getCurrentInstance()
  return vm.proxy.$router
}
